export default "__VITE_ASSET__DFCUHBpE__"